import { Action } from 'vuex';

import UserApi from 'Apis/User';
import InternalUserResponse from 'Entities/userLoginHistory/InternalUserResponse';

const state = {
    currentUser: undefined as InternalUserResponse | undefined,
};

export type UserState = typeof state;

export enum UserGetters {}

// type GettersReturn<G extends { [key in UserGetters]: (...args: any) => any }> = { [key in keyof G]: ReturnType<G[UserGetters]> };
// interface Getters {}

const getters = {};

export enum UserMutations {
    SET_CURRENT_USER = 'SET_CURRENT_USER',
    SET_NEW_QUOTA = 'SET_NEW_QUOTA',
}

const mutations: Record<UserMutations, (state: UserState, ...args: any) => void> = {
    SET_CURRENT_USER(state, currentUser) {
        state.currentUser = currentUser;
    },
    SET_NEW_QUOTA(state, quota: number) {
        const user = state.currentUser?.serialize();
        user!.availableQuota = quota;
        state.currentUser = new InternalUserResponse(user!);
    },
};

export enum UserActions {
    getCurrentUser = 'getCurrentUser'
}

const actions: Record<UserActions, Action<UserState, any>> = {
    async getCurrentUser({ commit }) {
        const { data: user } = await UserApi.getCurrentUser();
        commit(UserMutations.SET_CURRENT_USER, user);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
